export default "__VITE_ASSET__CJW3YEwF__"